module.exports = __webpack_public_path__ + "static/media/9.d53706ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/workoutPreview/img/9.png
// module id = 2116
// module chunks = 0